import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    LOG_LIST_PANEL_PREVIEW_IMAGE,
    PANEL_PRIORITIES,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { useQueryLoader } from '../../data-table/Loaders';
import ReportingDataTable from '../../data-table/ReportingDataTable';
import { radioFilterId, timeRangeFilterId } from '../../filters';

const title = t`Radio BSSIDs`;

const dataSource = {
    url: '/query/table',
    params: {
        type: 'radio',
        entityFields: ['name', 'bssidList'],
    },
    dataProperty: 'data.0.radio.bssidList',
};

const columns = [
    {
        type: COLUMN_TYPES.TEXT,
        title: t`SSID`,
        sortable: false,
        mapping: 'ssid',
        headerTooltip: t`The SSID of the radio`,
        width: 150,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`BSSID`,
        sortable: false,
        mapping: 'bssid',
        headerTooltip: t`The BSSID of the radio`,
        width: 150,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Security Type`,
        sortable: false,
        mapping: 'securityType',
    },
];

const sorters = [{ property: 'ssid', direction: 'asc' }];

function RadioBssidListPanel(props) {
    const loader = useQueryLoader(dataSource);
    return (
        <ReportingDataTable
            panelProps={props}
            loader={loader}
            columns={columns}
            sorters={sorters}
            showToolbar={false}
            showSearch={false}
            disableCSVExport
            disableColumnRemover
            deletedMapping="radio.deleted"
        />
    );
}

RadioBssidListPanel.propTypes = panelPropTypes;

RadioBssidListPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    hideActions: true,
    autoHeight: true,
    minContentHeight: 130,
};

export default Panel({
    typeAlias: 'RadioBssidList',
    catalogEntry: {
        category: PANEL_CATEGORIES.RADIO,
        priority: PANEL_PRIORITIES.SUBLIST,
        title,
        description: t`BSSIDs for selected radio`,
        previewImage: LOG_LIST_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, radioFilterId],
        optional: [],
    },
})(RadioBssidListPanel);
